import { render } from "./repeatables.vue?vue&type=template&id=583f1edc"
import script from "./repeatables.vue?vue&type=script&lang=js"
export * from "./repeatables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__